import type { AutomaticDeprovisioningRule } from "@octopusdeploy/octopus-server-client";
import humanizeDuration from "humanize-duration";

export function getAutomaticDeprovisioningRuleDescription(rule: AutomaticDeprovisioningRule) {
    const { ExpiryDays, ExpiryHours } = rule;
    const ms = (ExpiryDays * 24 + ExpiryHours) * 60 * 60 * 1000;
    if (ms === 0) return "No expiry";
    return humanizeDuration(ms, { largest: 2, round: true });
}
